import AppleLogin from "react-apple-login";
import { useRecoilValue } from "recoil";
import LoginButtonTemplatePromotion from "./LoginButtonTemplatePromotion";
import { userPromotionAtom } from "../../recoil/userPromotionAtom";
import { useState } from "react";
import { isDev } from "../../config";
import useAutoLoginPromotion from "../../hooks/useAutoLoginPromotion";

export default function AppleLoginButtonPromotion({
  render,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
}) {
  useAutoLoginPromotion();
  const user = useRecoilValue(userPromotionAtom);
  const [idToken, setIdToken] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const apple_cliendId = isDev
    ? "dev.orwellhealth.distancing.login"
    : "com.orwellhealth.distancing.login";

  const apple_promotion_redirectUrl = isDev
    ? "https://dev-www.distancing.im/promotion/oauth/apple"
    : `${window.location.origin}/promotion/oauth/apple`;

  return (
    <AppleLogin
      clientId={apple_cliendId}
      redirectURI={apple_promotion_redirectUrl}
      responseType="code id_token"
      responseMode="fragment"
      callback={(response: any) => {
        if (response?.authorization?.id_token) {
          setIdToken(response.authorization.id_token);
        }
        setIsLoading(false);
      }}
      render={
        render
          ? render
          : (props) => (
              <LoginButtonTemplatePromotion
                loginType="apple"
                action={() => {
                  setIsLoading(true);
                  props.onClick();
                }}
                isLoggedIn={!!user?.accessToken}
                isLoading={isLoading}
              />
            )
      }
    />
  );
}
